import React from "react";

// Invisible anti-bot field. Real users never see or fill it; bots that auto-fill
// every input will populate it, and the backend silently rejects those submissions.
export const Honeypot = ({ value, onChange }) => (
  <div aria-hidden="true" style={{ position: "absolute", width: 1, height: 1, padding: 0, margin: -1, overflow: "hidden", clip: "rect(0 0 0 0)", whiteSpace: "nowrap", border: 0 }}>
    <label>
      Website
      <input
        type="text"
        tabIndex={-1}
        autoComplete="off"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        data-testid="honeypot-field"
      />
    </label>
  </div>
);
